/**
 * What each chart widget currently shows, for its ⋯ menu (screenshots/89 Export): the live ECharts instance (PNG, SVG)
 * and the dataset result on screen after cross-filter / drill / zoom (CSV, link). DataWidget keeps these current;
 * WidgetMenu reads them when an item is picked. Not React state: nothing re-renders because a chart drew.
 */
import type * as echarts from "echarts/core";
import type { DataBinding } from "./charts/chartSettings";
import type { DatasetResult } from "./types";

export interface WidgetView { ds: DatasetResult; binding: DataBinding; title: string; filters: string }

export const chartInstances = new Map<string, echarts.ECharts>();
export const widgetViews = new Map<string, WidgetView>();

/** "client is caa · recipient is ward:39" → the CSV's "# Filters:" line. */
export const filtersText = (b: DataBinding) => b.filters.map((f) => `${f.field} ${f.op} ${Array.isArray(f.value) ? f.value.join("|") : f.value}`).join(" · ");
